export default "__VITE_ASSET__CRk6pTJh__"